import React from 'react';
import PropTypes from 'prop-types';
import {
  Autocomplete,
  TextField,
  ThemeProvider,
  makeStyles,
} from '@knockrentals/knock-shared-web';

const useStyles = makeStyles({
  autocomplete: {
    minWidth: 130,
    '& .MuiFormControl-root': {
      marginBottom: 0,
    },
  },
});

const ThresholdSelect = ({ ariaLabel, onChange, options, value }) => {
  const classes = useStyles();

  const getLabel = (optionValue) =>
    options.find((option) => option.value === optionValue)?.label ?? '';

  return (
    <ThemeProvider>
      <Autocomplete
        className={classes.autocomplete}
        disableClearable
        fullWidth
        getOptionDisabled={(option) => option.disabled}
        getOptionLabel={(option) => option?.label ?? getLabel(option)}
        getOptionSelected={(option, currentValue) =>
          option.value === currentValue
        }
        onChange={(event, newSelectedOption) =>
          onChange(newSelectedOption ? newSelectedOption.value : '')
        }
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            inputProps={{ ...params.inputProps, 'aria-label': ariaLabel }}
            size="small"
            variant="outlined"
          />
        )}
        size="small"
        value={value || ''}
      />
    </ThemeProvider>
  );
};

ThresholdSelect.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
  value: PropTypes.string,
};

export default ThresholdSelect;
